import get from '@pkg/utils/objects/get';
import numeric from './numeric';

/**
 * Siblings in the order they present: the order they state, and then the order
 * they came into being.
 *
 * An order is the client's to state and nothing enforces that a set of them is
 * dense or distinct, so two siblings can hold the same one — most often because
 * they were created together, which states no order between them at all. The id
 * settles it: ids are UUIDv7, so they are time ordered, and encoded short they
 * are fixed width over an alphabet that sorts the same way. Length first, so a
 * width that ever varies cannot read as a different era.
 *
 * Without it a tie falls to whatever order the collection was iterated in,
 * which survives a store update and not a reload, so the same design presents
 * two ways.
 *
 * @return {Function}
 */
export default function order() {
  const stated = numeric('order');

  return (a, b) => {
    const between = stated(a, b);
    if (between !== 0) return between;

    const left = get(a, 'uuid', '');
    const right = get(b, 'uuid', '');

    if (left.length !== right.length) return left.length - right.length;
    if (left === right) return 0;

    return left < right ? -1 : 1;
  };
}
